import { useEffect } from 'react'
import useGlobalStore from '@/store/useGlobalStore'
import { useRouter } from 'next/router'
import { useGTM } from './useGTM'

export const useInitGTMParameters = () => {
  const { gtm } = useGTM()
  const { pathname } = useRouter()

  const {
    user: { isSignedIn },
  } = useGlobalStore()

  useEffect(() => {
    setTimeout(() => {
      gtm.setParameters()
    }, 100)
  }, [isSignedIn, pathname])
}
